import { z } from "zod";

import type { IEndCampaignFormValues, IEndDateLimits } from "@/@types/campaign";

export const END_DATE_ERRORS = {
  required: "Selecione a data de encerramento",
  beforeToday: "A data não pode ser anterior a hoje",
  beforeStart: "A data não pode ser anterior ao início da campanha",
  notBeforeCurrentEnd: "A data deve ser anterior ao término atual",
} as const;

export function validateEndDate(
  endDate: string,
  limits: IEndDateLimits,
): string | null {
  if (!endDate) return END_DATE_ERRORS.required;
  if (endDate < limits.today) return END_DATE_ERRORS.beforeToday;
  if (endDate < limits.startDay) return END_DATE_ERRORS.beforeStart;
  if (endDate >= limits.currentEndDay) return END_DATE_ERRORS.notBeforeCurrentEnd;
  return null;
}

export function createEndCampaignSchema(
  limits: IEndDateLimits,
): z.ZodType<IEndCampaignFormValues> {
  return z.object({
    endDate: z.string().superRefine((value: string, context: z.RefinementCtx): void => {
      const message: string | null = validateEndDate(value, limits);
      if (!message) return;
      context.addIssue({ code: z.ZodIssueCode.custom, message });
    }),
  });
}
